import { render, staticRenderFns } from "./Prescriptions.vue?vue&type=template&id=a8b8794c&scoped=true&"
import script from "./Prescriptions.vue?vue&type=script&lang=js&"
export * from "./Prescriptions.vue?vue&type=script&lang=js&"
import style0 from "./Prescriptions.vue?vue&type=style&index=0&id=a8b8794c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8b8794c",
  null
  
)

export default component.exports